// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"fc1b6659","387":"20f177f1","670":"0067eef5","674":"24cc622f","699":"62826a31","843":"fc1b6659"}[chunkId] + ".chunk.css";
};